
import * as types from './types';
import actionCreatorFactory from 'typescript-fsa';
import { GenActionFactoryName } from 'shared/helpers/redux-helpers';
import { SyncDataMarking } from 'shared/api/api';

const actionCreator = actionCreatorFactory(GenActionFactoryName('markings'));

export const getSyncData = actionCreator.async<{ lastSyncDate: Date }, SyncDataMarking>(types.SYNC_DATA_MARKINGS);
